import { LinkBox } from "components";
import type { LinkBoxProps } from "components/LinkBox";
import type { ReactStoryblokComponent } from "types/storyblok";

const LinkBoxAdapter = ({ blok: { linkItems = [] } }: ReactStoryblokComponent<LinkBoxProps>) => {
  const links = linkItems.map(({ anchorText, url }) => ({ url: url || "/", anchorText }));

  return <LinkBox linkItems={links} />;
};

export default LinkBoxAdapter;
